var React = require('react');

function IconCloseCircleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m8.2 16.4a8.2 8.2 0 1 0 -8.2-8.2 8.2 8.2 0 0 0 8.2 8.2zm0-1.07a7.13 7.13 0 1 1 7.13-7.13 7.13 7.13 0 0 1 -7.13 7.13zm-2.2-4.05 2.2-2.28 2.24 2.24.84-.85-2.23-2.19 2.24-2.2-.85-.85-2.24 2.21-2.2-2.24-.89.88 2.24 2.2-2.24 2.23z","fill":"#c4ccd3"}));
}

IconCloseCircleInline.defaultProps = {"viewBox":"0 0 16.4 16.4"};

module.exports = IconCloseCircleInline;

IconCloseCircleInline.default = IconCloseCircleInline;
